// extracted by mini-css-extract-plugin
export default {"row":"DataDisplay_row__4AFfl","label":"DataDisplay_label__8HQgk","value":"DataDisplay_value__titV+"};